import Statistics from "../Statistics/Statistics";
import onlineCourse from "../../../assets/icons/statistics/onlineCourse.svg";
import { languages } from "../../../dummyData/dummyData";
import search from "../../../assets/icons/statistics/search.svg";
import star from "../../../assets/icons/statistics/star.svg";
import timeOnPlatform from "../../../assets/icons/statistics/timeOnPlatform.svg";
import progress from "../../../assets/icons/statistics/progress.svg";
import competences from "../../../assets/icons/statistics/competences.svg";
import {currencyFormat, dateFormat, percentageFormat} from "../../../utils/formatters";
import cpa from "../../../assets/icons/statistics/cpa.svg";
import alm from "../../../assets/icons/statistics/alm.svg";
import dollar from "../../../assets/icons/statistics/dollar.svg";
import TextTruncated from "../../atoms/TextTruncated/TextTruncated";
import Text from "../../atoms/Text/Text";
import TableWrapper from "../../molecules/TableWrapper/TableWrapper";
import Table from "../Table/Table";

const InstructorDashboardStatistics = ({ data, dateRange, currentSelected }) => {
  const {
    revenue,
    payments,
    start_rating,
    end_rating,
    start_completion_rate,
    end_completion_rate,
    start_pass_rate,
    end_pass_rate,
    start_search_hits,
    end_search_hits,
    video_usage,
    total_video_usage,
    practical_usage,
    total_practical_usage,
    material_usage,
    total_material_usage
  } = data;
  const usage = video_usage + practical_usage + material_usage;
  const total_usage = total_video_usage + total_practical_usage + total_material_usage;

  return (
    <Statistics
      header={`${languages.EN.labels.instructorStatistics} ${languages.EN.labels.for.toLowerCase()}: ${dateRange.name}`}
      data={[
        {
          icon: onlineCourse,
          content: languages.EN.labels.totalViewership,
          description: `${languages.EN.labels.minutesPlayedOutOfTotal}: ${Math.round(usage / 60)}/${Math.round(total_usage / 60)}`,
          value: total_usage > 0 ? usage / total_usage : 0,
          formatter: percentageFormat,
        },
      ].concat(dateRange.id === '0_0' ? [
        {
          icon: dollar,
          content: languages.EN.labels.totalRevenue,
          value: revenue,
          formatter: currencyFormat,
          description: (
            <TextTruncated lineClamp={1} style={{ width: "500px" }}>
              <Text s15 w400 lh18 dark-6>
                {languages.EN.labels.currentBalance}: {currencyFormat(revenue - payments.reduce((acc, curr) => acc + curr.amount, 0))}
                {payments.length > 0 ? (
                  <>
                    <br />
                    <br />
                    <TableWrapper
                      Table={() => (<Table columns={[
                        {
                          Header: languages.EN.labels.amount,
                          accessor: (data) => currencyFormat(data.amount),
                        },
                        {
                          Header: languages.EN.labels.date,
                          accessor: (data) => dateFormat(data.date),
                        },
                        {
                          Header: languages.EN.labels.accountNumber,
                          accessor: "account_no",
                        },
                      ]} data={payments} searchBar={false} pagination={false} />)}
                      title={languages.EN.labels.paymentHistory}
                    />
                  </>
                ) : null}
              </Text>
            </TextTruncated>
          ),
        },
      ] : [
        {
          icon: dollar,
          content: languages.EN.labels.totalRevenue,
          value: currentSelected ? languages.EN.placeholders.empty : currencyFormat(revenue),
          description: currentSelected ? languages.EN.messages.currentQuarterRevenue : null,
        },
      ]).concat([
        {
          icon: star,
          content: languages.EN.labels.instructorRating,
          value: end_rating,
          previousValue: start_rating,
          formatter: (value) => value.toFixed(2),
        },
        {
          icon: progress,
          content: languages.EN.labels.coursesCompletionPercentage,
          value: end_completion_rate,
          previousValue: start_completion_rate,
          formatter: (value) => percentageFormat(value),
        },
        {
          icon: competences,
          content: languages.EN.labels.coursesPassingPercentage,
          value: end_pass_rate,
          previousValue: start_pass_rate,
          formatter: (value) => percentageFormat(value),
        },
        {
          icon: search,
          content: languages.EN.labels.searchPopularity,
          value: end_search_hits,
          previousValue: start_search_hits,
        },
        {
          icon: timeOnPlatform,
          content: languages.EN.labels.videoViewership,
          description: `${languages.EN.labels.minutesPlayedOutOfTotal}: ${Math.round(video_usage / 60)}/${Math.round(total_video_usage / 60)}`,
          value: total_video_usage > 0 ? video_usage / total_video_usage : 0,
          formatter: percentageFormat,
        },
        {
          icon: cpa,
          content: languages.EN.labels.cpaViewership,
          description: `${languages.EN.labels.minutesPlayedOutOfTotal}: ${Math.round(practical_usage / 60)}/${Math.round(total_practical_usage / 60)}`,
          value: total_practical_usage > 0 ? practical_usage / total_practical_usage : 0,
          formatter: percentageFormat,
        },
        {
          icon: alm,
          content: languages.EN.labels.almViewership,
          description: `${languages.EN.labels.minutesPlayedOutOfTotal}: ${Math.round(material_usage / 60)}/${Math.round(total_material_usage / 60)}`,
          value: total_material_usage > 0 ? material_usage / total_material_usage : 0,
          formatter: percentageFormat,
        },
      ])}
    />
  );
};

export default InstructorDashboardStatistics
